<template>
  <div class="Male">
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 72 72">
      <path
        d="M63.66,19.65V8.34H52.35v4h4.48l-3.71,3.71A26.36,26.36,0,1,0,56,18.88l3.71-3.71v4.48ZM36,58.31A22.31,22.31,0,1,1,58.31,36,22.34,22.34,0,0,1,36,58.31Z"
        fill="#4727aa" />
      <text
        xml:space="preserve"
        style="
          font-style: normal;
          font-weight: normal;
          font-size: 21.1355px;
          line-height: 1.25;
          font-family: sans-serif;
          fill: #000000;
          fill-opacity: 1;
          stroke: none;
          stroke-width: 0.528389;
        "
        x="28.410883"
        y="38.110516"
        id="text66"
        transform="scale(0.90842243,1.1008095)">
        <tspan
          sodipodi:role="line"
          id="tspan64"
          x="28.410883"
          y="38.110516"
          style="stroke-width: 0.528389;">
          {{ age }}
        </tspan>
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  props: {
    age: {
      type: Number,
      default: 0,
    },
  },
  mounted() {},

  methods: {},

  computed: {},

  filters: {},
};
</script>

<style lang="scss" scoped>
.Male {
}
</style>
